var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Live = OCS.Viewer.Live || {};
OCS.Viewer.WorkerState = {started: false, online: false};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.get_data_worker = function () {
    if (!OCS.Viewer.Live.DataWorker) {
        OCS.Viewer.Functions.start_data_worker();
    }
    return OCS.Viewer.Live.DataWorker;
};
OCS.Viewer.Functions.listen_for_data_worker_message = function (method) {
    return OCS.Viewer.Functions.get_event_manager().subscribe({event_name: OCS.Viewer.Config.events.DATAWORKER_MESSAGE, callback: method, fire_immediately: true});
};
OCS.Viewer.Functions.on_data_worker_online = function () {
    OCS.Viewer.WorkerState.online = true;
    OCS.Viewer.Functions.get_event_manager().publish(OCS.Viewer.Config.events.DATAWORKER_ONLINE);
    OCS.Viewer.Functions.get_data_worker().onmessage = OCS.Viewer.Functions.on_data_worker_message;
};
OCS.Viewer.Functions.on_data_worker_message = function (msg) {
    if (msg && msg.options && OCS.Utilities.is_string(msg.options)) {
        try {
            // Try to decode the data
            msg.options = JSON.parse(msg.options);
        } catch (err) {
            console.error("DataWorker Parsing: " + err);
        }
    }
    OCS.Viewer.Functions.get_event_manager().publish(OCS.Viewer.Config.events.DATAWORKER_MESSAGE, msg);
    if (msg.cmd) {
        if (msg.options && msg.options.event && Object.values(OCS.Viewer.Config.events).contains(msg.options.event)) {
            OCS.Viewer.Functions.get_event_manager().publish(msg.options.event);
        }
        switch (msg.cmd) {
            case 'ping':
                OCS.Viewer.Functions.send_data_worker_message({
                    'cmd': 'ping'
                });
                break;
            case 'reinit':
                OCS.Viewer.Functions.get_event_manager().publish(OCS.Viewer.Config.events.REINIT_LAYERS);
                break;
            case 'restart':
                OCS.Viewer.Functions.get_event_manager().publish(OCS.Viewer.Config.events.RESTART_APPLICATION);
                break;
            case 'stopped':
                OCS.Viewer.Functions.get_event_manager().publish(OCS.Viewer.Config.events.APPLICATION_STOPPED);
                break;
            case 'console_debug':
                console.debug(msg.options.originator+":", msg.options.msg);
                break;
        }
    }
};
OCS.Viewer.Functions.send_data_worker_message = function (msg) {
    var dw = OCS.Viewer.Functions.get_data_worker();
    if (dw) {
        if (OCS.Viewer.Functions.use_workers()) {
            dw.add_to_msg_queue(msg);
        } else {
            dw.process_command({data: msg});
        }
    }
};
OCS.Viewer.Functions.start_data_worker = function () {
    if (!OCS.Viewer.WorkerState.started) {
        OCS.Viewer.WorkerState.started = true;
        if (OCS.Viewer.Functions.use_workers() && OCS.Functions.is_workers_supported()) {
            if (OCS.Viewer.Config.use_shared_worker && OCS.Functions.is_shared_workers_supported()) {
                return OCS.Viewer.Functions.start_data_worker_with_shared_worker();
            } else {
                return OCS.Viewer.Functions.start_data_worker_with_worker();
            }
        } else {
            return OCS.Viewer.Functions.start_data_worker_without_worker();
        }
        delete OCS.Viewer.Functions.start_data_worker_with_worker;
        delete OCS.Viewer.Functions.start_data_worker_without_worker;
    }
};
OCS.Viewer.Functions.start_data_worker_with_worker = function () {
    var wm = OCS.Functions.get_worker_manager();
    if (wm) {
        var worker = wm.register_worker({
            'msg_queue': [
                {'cmd': 'init', 'options': OCS.Viewer.Config.dataworker},
                {cmd: 'set_config', options: OCS.Viewer.Config},
                {cmd: 'set_user', options: OCS.User_data},
                {cmd: 'start'}
            ],
            'path': OCS.Package.root + OCS.Viewer.Functions.get_dataworker_path()
        });
        worker.options.time_to_msg_queue = 100;
        if (worker && worker.class_type === "WorkerHandler") {
            worker.addEvent('worker_online', OCS.Viewer.Functions.on_data_worker_online);
            OCS.Viewer.Live.DataWorker = worker;
        }
    } else {
        OCS.Viewer.Functions.start_data_worker_without_worker();
    }
};
OCS.Viewer.Functions.start_data_worker_with_shared_worker = function () {
    var wm = OCS.Functions.get_worker_manager();
    if (wm) {
        var worker = wm.register_shared_worker({
            'msg_queue': [{cmd: 'set_config', options: OCS.Viewer.Config}, {cmd: 'set_user', options: OCS.User_data}, {cmd: 'start'}],
            'init_msg': {
                'cmd': 'init',
                'options': OCS.Viewer.Config.dataworker
            },
            'path': OCS.Package.root + OCS.Viewer.Functions.get_dataworker_path()
        });
        worker.options.scope = "dataworker"; // Set here so that a scope will be defined at startup
        if (worker && worker.class_type === "WorkerHandler") {
            worker.addEvent('worker_online', OCS.Viewer.Functions.on_data_worker_online);
            OCS.Viewer.Live.DataWorker = worker;
        }
    } else {
        OCS.Viewer.Functions.start_data_worker_without_worker();
    }
};
OCS.Viewer.Functions.start_data_worker_without_worker = function () {
    if (!OCS.Viewer.Live.DataWorker) {
        if (!OCS.Worker || !OCS.Parsers.Classes.NexradLevel3 || !OCS.Worker.Classes.DataWorker) {
            // We don't have the file, have to go retrieve it
            OCS.Bootstrap.load_custom_file([{
                    load: [OCS.Package.root + OCS.Viewer.Functions.get_dataworker_path()],
                    complete: OCS.Viewer.Functions.start_data_worker_without_worker
                }]);
            return false;
        }
        //OCS.Worker.Classes.DataWorker.implement(OCS.Worker.Interfaces.DataWorkerWithoutW);
        OCS.Viewer.Live.DataWorker = new OCS.Worker.Classes.DataWorker(OCS.Viewer.Config.dataworker.class_options);
        OCS.Viewer.Live.DataWorker.addEvent('worker_message', OCS.Viewer.Functions.on_data_worker_message);
        OCS.Worker.Functions.send_to_main = OCS.Viewer.Functions.on_data_worker_message;
        OCS.Viewer.Functions.send_data_worker_message({cmd: 'set_config', options: OCS.Viewer.Config});
        OCS.Viewer.Functions.send_data_worker_message({cmd: 'start'});
        OCS.Viewer.Functions.get_event_manager().publish(OCS.Viewer.Config.events.DATAWORKER_ONLINE);
        return true;
    }
};
OCS.Viewer.Functions.stop_listen_for_data_worker_message = function (event_id) {
    return OCS.Viewer.Functions.get_event_manager().unsubscribe(event_id);
};
OCS.Viewer.Functions.destroy_data_worker = function () {
    if (OCS.Viewer.Live.DataWorker) {
        OCS.Viewer.Live.DataWorker.destroy();
        delete OCS.Viewer.Live.DataWorker;
        OCS.Viewer.WorkerState.started = false;
    }
};
